module.exports = __webpack_public_path__ + "img/hand-middle-finger.72be7cff.svg";